import { getConfig } from '@leagueplatform/config';
import { getCurrentBreakpoint } from '@leagueplatform/masonry-engine';

export const getMasonryRequestHeaders = () => {
  const timeZone =
    typeof Intl !== 'undefined'
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : 'America/Toronto';

  return {
    'X-League-Client-Platform': 'web',
    'X-League-Client-Time-Zone': timeZone,
    'X-League-Client-Version': getConfig().config.core.appVersion || '1.0.0',
    'X-League-Client-View-Size': getCurrentBreakpoint() || 'desktop', // default to desktop if no clientViewSize is provided. A string value is required for this header as it cannot be undefined
  };
};
